<template>
    <div class="userManageMent">
      <el-col :span="4">
          <el-menu default-active="1"   class="el-menu-vertical-demo"  ref="menu" @select="handleSelect">
            <template >
                <el-menu-item index="1" > <i class="el-icon-menu"></i> <span>账号管理</span> </el-menu-item>
                <el-menu-item index="2" > <i class="el-icon-menu"></i> <span>属性管理</span> </el-menu-item>
                <el-menu-item index="3" > <i class="el-icon-menu"></i> <span>文件属性</span> </el-menu-item>
            </template>
          </el-menu>
      </el-col>
      <!-- 账号管理 -->
      <el-col :span="18" v-if="userDataActive === true">
        <el-card style="margin-top:3%;margin-left:25%;margin-right:25%;width: 50%" >
          <el-table :max-height="tableHeight" :data="userData" style="width: 100%"  >
            <el-table-column
              prop="userName"
              label="账号"
              width="auto"
              min-width="30%">
            </el-table-column>
            <!-- <el-table-column
              prop="password"
              label="密码"
              width="auto"
              min-width="25%">
            </el-table-column> -->
            <el-table-column
              prop="type"
              label="账号类型"
              width="auto"
              min-width="40%">
            </el-table-column>
            <!-- <el-table-column
              prop="status"
              label="状态"
              width="auto"
              min-width="25%">
            </el-table-column> -->
            <el-table-column width="auto" min-width="30%">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="beforeUpdatePassword(scope.$index, scope.row)">修改密码</el-button>
                <!-- <el-button
                  size="mini"
                  type="danger"
                  @click="handleSee(scope.$index, scope.row)">查看</el-button>
                <el-button
                  size="mini"
                  type="success"
                  @click="handleUpdate(scope.$index, scope.row)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <el-button type="warning" round style="margin-top:3%" @click="logout">退出登录</el-button>
        </el-card>

        <!-- 修改密码框 -->
        <el-dialog title="修改密码" :visible.sync="updatePasswordVisible">
          <el-row>
            <el-col :span="4" style="margin-top:1%">账号名字</el-col>
            <el-col :span="18">
              <el-input v-model="selectedUser.userName"  disabled> </el-input>
            </el-col>
          </el-row>
          <el-row style="margin-top:2%">
            <el-col :span="4" style="margin-top:1%">旧密码</el-col>
            <el-col :span="18">
              <el-input placeholder="请输入旧密码"  v-model="oldPassword" show-password clearable> </el-input>
            </el-col>
          </el-row>
          <el-row style="margin-top:2%">
            <el-col :span="4" style="margin-top:1%">新密码</el-col>
            <el-col :span="18">
              <el-input placeholder="请输入新密码"  v-model="newPassword"  show-password clearable> </el-input>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button @click="updatePasswordVisible = false">取 消</el-button>
            <el-button type="primary" @click="updatePassword">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>

      <!-- 修改属性 -->
      <el-col :span="18"  v-if="propertyDataActive === true">
        <el-card style="margin-top:3%;margin-left:20%;margin-right:20%" >
          <el-table :max-height="tableHeight" :data="propertyData.filter(data => !tableSearch || data.label.toLowerCase().includes(tableSearch.toLowerCase()))"
          style="width: 100%"  >
            <!-- <el-table-column
              label="序号"
              type="index"
              width="100px">
            </el-table-column> -->
            <!-- <el-table-column
                        label="序号"
                        type="index"
                        width="auto"
                        min-width="10%">
            </el-table-column> -->
            <el-table-column
              prop="label"
              label="属性名称"
              width="auto"
              min-width="60%">
            </el-table-column>
            <el-table-column width="auto" min-width="40%">
              <template slot="header" slot-scope="scope">
                    <el-input v-model="tableSearch" size="mini" placeholder="输入属性名称搜索"/>
              </template>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="updatePropertyBefore(scope.$index, scope.row)">修改</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDeletePropertyBefore(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div style=" left:50% ;bottom: 5%; position:fixed">
          <el-button type="primary" @click="newPropertyVisible = true">新建属性</el-button>
        </div>
        <!-- 新增属性框 -->
        <el-dialog title="新建属性" :visible.sync="newPropertyVisible">
          <el-row>
            <el-col :span="4" style="margin-top:1%">新属性名字:</el-col>
            <el-col :span="18">
              <el-input placeholder="请输入新属性名字"  v-model="newPropertyName"  clearable> </el-input>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button @click="newPropertyVisible = false">取 消</el-button>
            <el-button type="primary" @click="createNewProperty">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 修改属性框 -->
        <el-dialog title="修改属性" :visible.sync="updatePropertyVisible">
          <el-row>
            <el-col :span="4" style="margin-top:1%">旧属性名字</el-col>
            <el-col :span="18">
              <el-input v-model="oldProperty.label"  disabled> </el-input>
            </el-col>
          </el-row>
          <el-row style="margin-top:2%">
            <el-col :span="4" style="margin-top:1%">新属性名字</el-col>
            <el-col :span="18">
              <el-input placeholder="请输入新属性名字"  v-model="updatePropertyName"  clearable> </el-input>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button @click="updatePropertyVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateProperty">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>

      <!-- 文件类型 -->
      <el-col :span="18"  v-if="fileTypeDataActive === true">
          <el-card style="margin-top:3%;margin-left:20%;margin-right:20%" >
            <el-table :max-height="tableHeight" :data=fileTypeData style="width: 100%"  >
              <el-table-column
                prop="name"
                label="文件类型"
                width="auto"
                min-width="60%">
              </el-table-column>
              <el-table-column width="auto" min-width="40%">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="updateFileTypeBefore( scope.row)">修改</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDeleteFileTypeBefore(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
          <div style=" left:50% ;bottom: 5%; position:fixed">
            <el-button type="primary" @click="fileTypeVisible = true">新增分类</el-button>
          </div>
          <!-- 新增文件分类 -->
          <el-dialog title="新建分类" :visible.sync="fileTypeVisible">
            <el-row>
              <el-col :span="4" style="margin-top:1%">新分类名字:</el-col>
              <el-col :span="18">
                <el-input placeholder="请输入新分类名字"  v-model="newFileType"  clearable> </el-input>
              </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
              <el-button @click="fileTypeVisible = false">取 消</el-button>
              <el-button type="primary" @click="createNewFileType">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 修改文件分类框 -->
          <el-dialog title="修改属性" :visible.sync="updateFileTypeVisible">
            <el-row>
              <el-col :span="4" style="margin-top:1%">旧分类名字</el-col>
              <el-col :span="18">
                <el-input v-model="oldFileType.name"  disabled> </el-input>
              </el-col>
            </el-row>
            <el-row style="margin-top:2%">
              <el-col :span="4" style="margin-top:1%">新分类名字</el-col>
              <el-col :span="18">
                <el-input placeholder="请输入新分类名字"  v-model="updateFileTypeName"  clearable> </el-input>
              </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
              <el-button @click="updateFileTypeVisible = false">取 消</el-button>
              <el-button type="primary" @click="updateFileType">确 定</el-button>
            </div>
          </el-dialog>
        </el-col>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'UserManageMent',
  data () {
    return {
      userData: [],
      userDataActive: false,
      propertyData: [],
      tableSearch: '',
      propertyDataActive: false,
      tableHeight: window.innerHeight * 0.7,
      newPropertyVisible: false,
      newPropertyName: '',
      updatePropertyVisible: false,
      updatePropertyName: '',
      oldProperty: {},
      updatePasswordVisible: false,
      oldPassword: '',
      newPassword: '',
      selectedUser: {},
      fileTypeDataActive: false,
      fileTypeData: [],
      newFileType: '',
      fileTypeVisible: false,
      updateFileTypeVisible: false,
      oldFileType: {},
      updateFileTypeName: ''
    }
  },
  mounted () {
    this.getProperty()
  },
  methods: {
    handleSelect (key, keyPath) {
      // eslint-disable-next-line eqeqeq
      if (key == 1) {
        this.fileTypeDataActive = false
        this.propertyDataActive = false
        this.userDataActive = true
        this.getUsers()
      // eslint-disable-next-line eqeqeq
      } else if (key == 2) {
        this.userDataActive = false
        this.fileTypeDataActive = false
        this.propertyDataActive = true
        this.getProperty()
      // eslint-disable-next-line eqeqeq
      } else if (key == 3) {
        this.userDataActive = false
        this.fileTypeDataActive = true
        this.propertyDataActive = false
        this.getFileType()
      }
    },
    createNewProperty () {
      this.$axios.post(Common.baseUrl + 'property/addProperty', {name: this.newPropertyName}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '新增属性成功',
            type: 'success'
          })
          this.getProperty()
          this.newPropertyVisible = false
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    getProperty () {
      this.$axios({
        method: 'get',
        url: Common.baseUrl + 'property/get'
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          // console.log(res.data.data)
          this.propertyData = res.data.data
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    updatePropertyBefore (index, row) {
      this.oldProperty = row
      this.updatePropertyVisible = true
    },
    updateProperty () {
      this.$axios.post(Common.baseUrl + 'property/updateProperty', {oldId: this.oldProperty.value, newName: this.updatePropertyName}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '修改属性成功',
            type: 'success'
          })
          this.getProperty()
          this.updatePropertyVisible = false
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handleDeletePropertyBefore (index, row) {
      this.$confirm('是否删除属性     ' + row.label, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDeleteProperty(row.value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleDeleteProperty (id) {
      this.$axios.get(Common.baseUrl + 'property/deleteById', {params: {id: id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getProperty()
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    logout () {
      this.$axios.post(Common.baseUrl + 'user/logout'
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          localStorage.clear()
          this.$router.push('/login')
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          localStorage.clear()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    getUsers () {
      this.$axios.post(Common.baseUrl + 'user/getAllUsers'
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.userData = res.data.data
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    beforeUpdatePassword (index, row) {
      this.selectedUser = row
      this.updatePasswordVisible = true
    },
    updatePassword () {
      let data = {id: this.selectedUser.id, oldPassword: this.oldPassword, newPassword: this.newPassword}
      this.$axios.post(Common.baseUrl + 'user/updatePassword', data
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.updatePasswordVisible = false
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    getFileType () {
      this.$axios({
        method: 'get',
        url: Common.baseUrl + 'fileType/allType'
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          // console.log(res.data.data)
          this.fileTypeData = res.data.data
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    updateFileTypeBefore (row) {
      this.oldFileType = row
      this.updateFileTypeVisible = true
    },
    handleDeleteFileTypeBefore (row) {
      this.$confirm('是否删除分类     ' + row.name, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDeleteFileType(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleDeleteFileType (row) {
      this.$axios({
        method: 'get',
        url: Common.baseUrl + 'fileType/deleteType',
        params: {id: row.id}
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.getFileType()
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    createNewFileType () {
      this.$axios({
        method: 'get',
        url: Common.baseUrl + 'fileType/addType',
        params: {name: this.newFileType}
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.getFileType()
          this.fileTypeVisible = false
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    updateFileType () {
      this.$axios.post(Common.baseUrl + 'fileType/updateType', {oldId: this.oldFileType.id, newName: this.updateFileTypeName}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '修改属性成功',
            type: 'success'
          })
          this.getFileType()
          this.updateFileTypeVisible = false
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserManageMent.vue